module.exports = __webpack_public_path__ + "static/media/Picture1[1].3988f9d5.png";